module.exports = __webpack_public_path__ + "img/1534832600.68c50a87.jpg";